import React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { grFieldSx } from "src/design-system/components/GrTextField";

// Date range fields of the Weight Tracker check-ins (inside GrFilterDrawer): start, end.
export default function WeightFilter({ filterData, handleSelectOther }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label="Start date"
        inputFormat="dd-MM-yyyy"
        value={filterData.date_from}
        onChange={(newValue) => {
          handleSelectOther("date_from", newValue);
        }}
        renderInput={(params) => (
          <TextField {...params} name="date_from" required fullWidth sx={grFieldSx} />
        )}
      />
      <DatePicker
        label="End date"
        inputFormat="dd-MM-yyyy"
        value={filterData.date_to}
        onChange={(newValue) => {
          handleSelectOther("date_to", newValue);
        }}
        renderInput={(params) => (
          <TextField {...params} name="date_to" required fullWidth sx={grFieldSx} />
        )}
      />
    </LocalizationProvider>
  );
}
